export default "__VITE_ASSET__VepSHRNh__"